module.exports = __webpack_public_path__ + "img/es.edf3e8f3.png";